import { render, staticRenderFns } from "./form-component-combobox.vue?vue&type=template&id=8c449a5c&scoped=true"
import script from "./form-component-combobox.vue?vue&type=script&lang=ts"
export * from "./form-component-combobox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c449a5c",
  null
  
)

export default component.exports